<label class="assignee-filter">
  <span>{{ label }}</span>
  <select [ngModel]="selected" (ngModelChange)="change($event)">
    <option value="">{{ t('company.assign.all', 'Все') }}</option>
    <option value="none">{{ t('company.assign.none', 'Не назначен') }}</option>
    <option *ngFor="let o of options" [value]="o.id">{{ o.fullName }}</option>
  </select>
</label>
